<template>
  <section>
    <Photo
      v-for="photo in stepDatas($route.name)"
      :label="photo.label"
      :name="photo.name"
      :photo="photo.value"
      :key="photo.name"/>

    <p>
      <small>* Champ obligatoire</small>
      <small class="help app">
        <a href="https://www.allianz.fr/assurance-auto/mon-releve-kilometrique" target="_blank">Une question, un problème ? Cliquez ici</a>
      </small>
    </p>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Photo from '@/components/Photo'

  export default {
    components: {
      Photo
    },
    computed: mapGetters(['stepDatas']),
  }
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  section {

    @include media('>tablet') {
      // display: flex;
      flex-wrap: wrap;
    }
  }

  small {
    display: block;
    padding-left: spacer();
    padding-right: spacer();
    font-size: .9em;
    opacity: .5;
  }

  .help {
    &.app {
      text-align: left;
      width: 100%;
      display: block;
      margin-top: 5px;

      a {
        color: #00a9e0;
        font-size: 1.2em;
        text-decoration: none;
        margin-left: 8px;
      }
    }
  }
</style>
